import gsap from "gsap";
import { ScrollTrigger } from "gsap/src/all";

export const aniEducationalContent = (
    root: React.MutableRefObject<null>,
    variant: string
) => {
    console.log("🚀 ~ variant:", variant);
    const componentSelector = gsap.utils.selector(root);

    if (variant === "left") {
        //Setup inital animation properties
        gsap.set(
            [
                componentSelector("#left-heading"),
                componentSelector("#left-description"),
                componentSelector("#left-cta"),
            ],
            { opacity: 0, y: "10px" }
        );

        //Setup scroll trigger and animations
        ScrollTrigger.create({
            trigger: root.current,
            endTrigger: componentSelector("#left-heading"),
            start: "top 90%",
            end: "top 90%",
            once: true,
            onEnter: () => {
                gsap.to(
                    [
                        componentSelector("#left-heading"),
                        componentSelector("#left-description"),
                        componentSelector("#left-cta"),
                    ],
                    { opacity: 1, y: "0px", stagger: 0.15 }
                );
            },
        });
    }

    if (variant === "video") {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: root.current,
                start: "top 100%",
                end: "=+300px",
                scrub: 0.2,
            },
        });
        gsap.set(componentSelector(".left"), { y: -40 });
        tl.to(componentSelector(".left"), { y: 0 });
    }

    if (variant === "dual" || variant === "image_double") {
        //Setup inital animation properties
        gsap.set(
            [
                componentSelector("#column-left-heading"),
                componentSelector("#column-left-description"),
            ],
            { opacity: 0 }
        );
        gsap.set(componentSelector(".right"), {
            y: -120,
        });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: root.current,
                start: "top 100%",
                end: "=+1000px",
                scrub: 0.2,
            },
        });

        tl.to(componentSelector(".right"), { y: 0 }, 0);
        tl.to(componentSelector(".left"), { y: 100 }, 0);

        //Left column heading animations
        ScrollTrigger.create({
            trigger: componentSelector("#column-left-heading"),
            start: "top 70%",
            once: true,
            onEnter: () => {
                gsap.to(
                    [
                        componentSelector("#column-left-heading"),
                        componentSelector("#column-left-description"),
                    ],
                    { opacity: 1, stagger: 0.15 }
                );
            },
        });
    }
    if (variant === "v2") {
        const scrollAnimationv2 = gsap.fromTo(
            componentSelector("#v2"),
            { y: "100px" },
            { y: "0px" }
        );

        ScrollTrigger.create({
            animation: scrollAnimationv2,
            trigger: componentSelector("#v2"),
            start: "top 75%",
            end: "+=300px",
            scrub: 1,
        });

        gsap.set(componentSelector("#v2"), {
            y: "100px",
        });
    }
    const id = (root.current as HTMLElement | null)?.id;
    console.log("🚙 EducationalContentAnimations", id);
};

export const aniEducationalContentKill = (
    root: React.MutableRefObject<null>
) => {
    gsap.killTweensOf(root.current);
    const id = (root.current as HTMLElement | null)?.id;
    console.log("🚗 EducationalContentAnimations killed", id);
};
